<app-tasks-queue-card
  *ngIf="componentStore.isShown$ | async"
  [progress]="componentStore.progress$ | async"
  (closeCard)="componentStore.setIsShown(false)"
>
  <div title>
    <h5 class="modal-title fs-6">{{ 'CAMPAIGNS.CREATE_WIZARD.AUTO_MODERATION.TASK_TITLE' | translate }}</h5>
    <div class="text-gray-600">
      {{ 'CAMPAIGNS.CREATE_WIZARD.AUTO_MODERATION.TASK_SUBTITLE' | translate }}:
      <ng-container *ngIf="componentStore.banners$ | async as banners; else bannersCountLoader">
        {{banners.length}}
      </ng-container>
      <ng-template #bannersCountLoader>
        <app-skeleton-loader class="h-15px w-15px"></app-skeleton-loader>
      </ng-template>
    </div>
  </div>

  <div>
    <ng-container *ngIf="componentStore.banners$ | async as banners; else bannersAreLoading">
      <div
        *ngFor="let bannerWrapper of banners"
        class="px-5 py-4 border-bottom border-secondary"
        test-id="auto-accept-modal.banner-item"
      >
        <div class="position-relative d-flex align-items-center justify-content-between ps-10">
          <ng-container [ngSwitch]="bannerWrapper.status$ | async">
            <span
              *ngSwitchCase="ACCEPT_STATUSES.SUCCESS"
              class="svg svg-icon svg-icon-1 svg-icon-success position-absolute start-0"
              [inlineSVG]="ICON_CHECK_CIRCLE"
              test-id="auto-accept-modal.banner-status-success"
            ></span>
            <span
              *ngSwitchCase="ACCEPT_STATUSES.FAILED"
              class="svg svg-icon svg-icon-1 svg-icon-danger position-absolute start-0"
              [inlineSVG]="ICON_CLOSE_CIRCLE"
              test-id="auto-accept-modal.banner-status-failed"
            ></span>
            <div
              *ngSwitchDefault
              class="spinner-border w-20px h-20px text-success position-absolute start-0 opacity-50"
              role="status"
              test-id="auto-accept-modal.banner-status-pending"
            ></div>
          </ng-container>
          <div class="text-gray-600 fw-bolder">{{bannerWrapper.banner.name}}</div>
          <div
            *ngIf="bannerWrapper.banner.bannerDisplayDto.ads[0].images.length === 1"
            class="badge bg-secondary bg-opacity-50 text-dark fw-bold lh-base"
          >
            {{bannerWrapper.banner.bannerDisplayDto.ads[0].images[0].width}}x{{bannerWrapper.banner.bannerDisplayDto.ads[0].images[0].height}}
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #bannersAreLoading>
      <app-auto-accept-banners-item-skeleton
        *ngFor="let i of [].constructor(3); let isLast = last"
        [hasBorder]="!isLast"
      ></app-auto-accept-banners-item-skeleton>
    </ng-template>
  </div>
</app-tasks-queue-card>
